import React, { useEffect, useMemo, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { useFormState, useForm } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { OnChange } from 'react-final-form-listeners';
import QCXAutocompleteSelect from '../../../../shared-components/autocomplete-select/QCXAutocompleteSelect' // lista suspensa
import MultiSelectFormInput from '../../../../ts/common/components/forms/MultiSelectFormInput';

export default function Lista({
    metadado, 
    isConsult,
    basePath="",
    ncm=false,
    ...restProps

}) {

    const [label, setLabel] = useState("")
    const [name,  setName] = useState("")
    const [obrigatorio, setObrigatorio] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [listValores, setListValores] = useState([]);
    const [defaultValue, setDefaultValue] = useState('');
    const [tamanhoMaximo, setTamanhoMaximo] = useState(null);
    const path = `atributosPreenchidos`
    const form = useForm();


    const filterOptions = createFilterOptions({
        stringify: (item) => `${item.codigo} - ${item.value}`,
    });


    useEffect(() => {
      if (!ncm) {
        setName(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valor`)
      } else {
        setName(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valor`)
      }
      
      setLabel(metadado?.nome);
      setObrigatorio(metadado?.validacao?.obrigatorio || false);
   
      if (metadado?.validacao?.dominios) {
        const dominio = metadado?.validacao?.dominios;

        setListValores([...dominio].map(el => ({
            id: el.id,
            value: `${el.descricao}`,
        })))

        setDefaultValue({ id: null, value: '' });
      }

    }, [metadado])

    if (!name) {
        return null;
    }

    return (
        <Grid item xs={12} sm={6} md={4}>
            <QCXAutocompleteSelect
                label={label}
                id={name}
                name={name}
                options={listValores}
                filterOptions={filterOptions}
                defaultValue={defaultValue}
                getOptionLabel={(item) => (
                    item.value ? item.value : ''
                )}
                required={obrigatorio}
                isConsult={isConsult}
                disabled={isConsult}
                {...restProps}
            />
        </Grid>
    )
    
    

}
